import { ogLocale as getOgLocale } from "../../services/localeCodes";
import { resolveSiteMetadata } from "../../services/siteMetadata";
import { eventImage } from "../../services/eventMetadata";
import Head from "next/head";
import {ASSET_URL, DEBUG} from "../../config";
import {buildCanonicalUrl} from "../../components/normalizeMenuUrl";


/**
 * Meta SEO pour toutes les pages Travel.
 *
 * Gère :
 *  - Title + description
 *  - OpenGraph (og:title, og:description, og:image, og:url, og:type, og:locale, og:site_name)
 *  - Twitter Card (summary_large_image)
 *  - Canonical + robots
 *  - Keywords (optionnel via config)
 *  - JSON-LD arbitraire passé via prop `jsonLd` (objet ou tableau d'objets)
 */
export default function Meta({context, title, description, image, type, jsonLd, keywords, noindex, seo})
{
    ({title, description, image} = resolveSiteMetadata(context, {title, description, image: eventImage(context, image)}, seo));
    var finalImage=context.org.logo
    if(image){
        finalImage=image
    }

    if(finalImage && !finalImage.startsWith("http")){
        finalImage=ASSET_URL+finalImage
    }

    var titlePrefix=context.org.name || "Unisoft"
    if(context.org.domain){
        titlePrefix=context.org.domain
    }

    if(DEBUG){
        title="(Dev) "+title
    }

    const cleanTitle = (title || "").replace("<!-- -->", "")
    const fullTitle = cleanTitle + " | " + titlePrefix
    const siteName = context.org.name || titlePrefix
    const ogType = type || "website"

    // URL canonique : schéma de BASE_WEB_URL + host/path courant (query retirée pour
    // éviter les duplicates). context.url contient déjà host+préfixe → cf. buildCanonicalUrl.
    const canonical = buildCanonicalUrl(context.org, context.url)

    // og:locale : convention Facebook (fr_FR, en_US, he_IL…)
    const lang = context.lang?.value || context.lang || "fr"
    const ogLocale = getOgLocale(lang)

    const robots = noindex ? "noindex,nofollow" : "index,follow"

    const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : []

    return(
        <div>
            <Head>
                <meta charSet="utf-8"/>
                <meta name="viewport" content="width=device-width,initial-scale=1.0"/>

                <title>{fullTitle}</title>
                <meta name="description" content={description}/>
                {keywords && <meta name="keywords" content={keywords}/>}
                <meta name="robots" content={robots}/>

                {canonical && <link rel="canonical" href={canonical}/>}
                <link rel="icon" href={context.org.logo}/>

                <meta property="og:title" content={cleanTitle}/>
                <meta property="og:description" content={description}/>
                <meta property="og:image" content={finalImage}/>
                <meta property="og:type" content={ogType}/>
                <meta property="og:site_name" content={siteName}/>
                <meta property="og:locale" content={ogLocale}/>
                {canonical && <meta property="og:url" content={canonical}/>}

                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={cleanTitle}/>
                <meta name="twitter:description" content={description}/>
                <meta name="twitter:image" content={finalImage}/>

                {jsonLdArray.map((ld, i) => (
                    <script
                        key={i}
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{__html: JSON.stringify(ld)}}
                    />
                ))}
            </Head>

        </div>
    )
}
